<template>
    <div class="mb-5">

        <template v-if="stateEmpty">
            <button class="btn-unstyled sau-font-bold text-success text-sm" @click.prevent="adding = true" aria-label="Add a coupon to your order"><i class="far fa-tag"></i> Add a coupon</button>
        </template>

        <template v-if="stateAdding">
            <form class="row align-items-center mb-3 pl-4">
                <input id="couponCode" type="text" class="form-control col-9 text-sm" v-model="code" placeholder="Coupon Code" aria-label="Enter coupon Code">
                <div class="col-3">
                    <button class="btn-success text-sm w-100 text-center p-2" @click.prevent="applyCouponToOrder()" :disabled="! canApply" aria-label="Add coupon">
                        <i v-if="processing" class="far fa-spinner-third fa-spin"></i>
                        <i v-else class="fas fa-check"></i>
                    </button>
                </div>
                <p v-if="error" class="text-muted small mb-0">{{ this.error }}</p>
            </form>
        </template>

        <template v-if="stateAdded">
            <div class="text-sm row mb-1">
                <div class="col-8">
                    <button class="btn-unstyled text-muted hover:text-danger" @click.prevent="removeCouponFromOrder()" :disabled="! canRemove" title="Remove coupon" aria-label="Remove coupon">
                        <i v-if="processing" class="far fa-spinner-third fa-spin"></i>
                        <i v-else class="far fa-trash"></i>
                    </button>
                    <p class="d-inline">{{ this.coupon.code }}</p>
                </div>
                <div class="col-4 text-right align-self-end">
                    <p class="mb-0 text-success sau-font-bold">-{{ this.coupon.discount | currency }}</p>
                </div>
            </div>
        </template>

    </div>
</template>

<script>

    export default {
        name: "Coupon",

        inject: ['applyCoupon', 'removeCoupon'],
        props: ['coupon'],

        data() {
            return {
                code: null,
                error: null,
                terms: null,
                processing: false,
                adding: false,
            }
        },

        methods: {

            applyCouponToOrder() {
                this.error = null;
                this.processing = true;

                this.applyCoupon(this.code)
                    .then((coupon) => {

                        this.$swal({
                            toast: true,
                            type:'success',
                            title: 'Coupon Successfully Applied',
                            showConfirmButton: false,
                            timer: 2000,
                        });

                        this.adding = false;
                        window.bus.$emit('coupon.applied');
                    })
                    .catch(error => {
                        this.error = 'Coupon has either expired or is invalid.';
                    })
                    .finally(() => {
                        this.processing = false;
                    });
            },

            removeCouponFromOrder() {
                this.processing = true;

                this.removeCoupon().then(() => {
                    this.code = this.error = this.terms = null;
                    window.bus.$emit('coupon.removed');

                }).catch(error => {
                    this.error = error;

                }).finally(() => {
                    this.processing = false;
                });
            },

        },

        computed: {
            canApply() {
                return ! this.processing &&
                    ((typeof this.code) === 'string' && this.code.length >= 1);
            },
            canRemove() {
                return !! (! this.processing && this.coupon.code);
            },
            stateEmpty() {
                return !! _.isEmpty(this.coupon) && ! this.adding;
            },
            stateAdding() {
                return !! this.adding;
            },
            stateAdded() {
                return !! ! _.isEmpty(this.coupon);
            }
        }
    }
</script>